import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ClientLocaleProvider} from "./context/client_locale";
import {DashboardLocaleProvider} from "./context/dashboard_locale";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ClientLocaleProvider>
          <DashboardLocaleProvider>
              <App />
          </DashboardLocaleProvider>
      </ClientLocaleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
